import { Component, input, output } from '@angular/core';

import { PrivaLocalizationModule } from '@priva/localization';

import { ProductBoxAmountComponent, TerminalOverlayComponent } from 'app/shared/components';
import { ProductBoxRegistration } from 'app/shared/components/product-box/models';
import { Activity, ActivityType } from 'app/shared/features/activity-selector/models';
import { areProductBoxRegistrationArraysEqual, areProductBoxRegistrationsValid } from 'app/shared/utils';

import { ManualFlowFooterComponent } from '../manual-flow-footer/manual-flow-footer.component';

@Component({
    selector: 'app-manual-input-product-box-amount',
    templateUrl: './manual-input-product-box-amount.component.html',
    styleUrl: './manual-input-product-box-amount.component.scss',
    imports: [
        ProductBoxAmountComponent,
        PrivaLocalizationModule,
        ManualFlowFooterComponent,
        TerminalOverlayComponent,
    ],
})
export class ManualInputProductBoxAmountComponent {
    activity = input(undefined, {
        transform: (value: Activity | undefined) => {
            this._activity = value;
            if (!this.productBoxRegistrations.length && value?.defaultProductBoxNumber !== undefined) {
                this.productBoxRegistrations = [
                    { productBoxNumber: value.defaultProductBoxNumber, amount: undefined },
                ];
            }
            return this._activity;
        },
    });
    title = input<string>('');
    activityType = input<ActivityType | undefined>();

    productBoxAmountsSelected = output<ProductBoxRegistration[]>();
    closeRequested = output<void>();
    finishRequested = output<void>();

    _activity: Activity | undefined;
    productBoxRegistrations: ProductBoxRegistration[] = [];
    private hasError = false;

    onCloseRequested() {
        this.closeRequested.emit();
    }

    onProductBoxRegistrationsUpdated(formValues: {
        productBoxRegistrations: ProductBoxRegistration[];
        hasError: boolean;
    }) {
        this.hasError = formValues.hasError;
        if (this.hasError) return;
        if (
            !areProductBoxRegistrationArraysEqual(
                this.productBoxRegistrations,
                formValues.productBoxRegistrations,
            ) &&
            !formValues.hasError
        ) {
            this.productBoxRegistrations = formValues.productBoxRegistrations;
        }
    }

    onSelectionComplete() {
        if (this.productBoxRegistrations.length) {
            const productRegistrations = this.productBoxRegistrations.filter(
                (productBoxRegistration) =>
                    productBoxRegistration.amount && productBoxRegistration.productBoxNumber,
            );
            this.productBoxAmountsSelected.emit(productRegistrations);
        }
    }

    areProductRegistrationsValid() {
        return !!(
            !this.hasError &&
            this._activity &&
            areProductBoxRegistrationsValid(this.productBoxRegistrations, this._activity)
        );
    }

    onFinishRequested(): void {
        this.finishRequested.emit();
    }
}
